import { Rank, RankList } from './Columns'

interface Props {
  rankId: number
  rankList: RankList
}

const RankCell = ({ rankId, rankList = [] }: Props) => {
  return (
    <div>
      {(rankList && rankId && rankList.find((rank: Rank) => rank.id === rankId)?.value) || ''}
    </div>
  )
}

export default RankCell
